import { RouteType } from "types/RouteType";
import {
  evereeOnboardingRoute,
  evereeHomeRoute,
  evereeTaxDocumentsRoute,
  evereePaymentHistoryRoute,
  evereePaymentDepositRoute,
  evereeHomeAddressRoute,
} from "./Everee.Route";
import {
  evereeWorkerManagementRoute,
  evereeTimesheetManagementRoute,
  evereePayrollOperationsRoute,
  evereeWorkLocationsRoute,
  evereeFinancialReportsRoute,
} from "./admin/EvereeAdmin.Route";
import {
  earningProfilesRoute,
  deductionProfilesRoute,
} from "./admin/profiles/ProfileRoutes";
import { lniCodesRoute } from "./admin/lni/LNIRoutes";
import { vendingIntegrationRoute } from "./admin/vending/VendingIntegration.Route";
import { bulkPaystubRoute } from "./admin/bulkpaystubs/BulkPaystub.Route";

const payrollRoutesList: RouteType[] = [
  // Worker self-service routes
  evereeOnboardingRoute,
  evereeHomeRoute,
  evereeTaxDocumentsRoute,
  evereePaymentHistoryRoute,
  evereePaymentDepositRoute,
  evereeHomeAddressRoute,
  // Admin routes
  evereeWorkerManagementRoute,
  evereeTimesheetManagementRoute,
  evereePayrollOperationsRoute,
  evereeWorkLocationsRoute,
  evereeFinancialReportsRoute,
  // Profile management routes
  earningProfilesRoute,
  deductionProfilesRoute,
  // LNI management routes
  lniCodesRoute,
  // Vending integration (Phase 5)
  vendingIntegrationRoute,
  // Bulk paystub printing
  bulkPaystubRoute,
];

export default payrollRoutesList;
